<div class="max-w-[calc(var(--dsb-content-max-width)-2rem)] flex flex-col gap-md">
    <hlm-dialog-header>
        <span class="text-xl font-semibold">{{ title }}</span>
    </hlm-dialog-header>
    <div class="text-md text-text-primary">{{ message }}</div>
    <button hlmButton id="close-button" hlmBtn class="w-full" (click)="close()">Close</button>
</div>
